import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid, Paper } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import SwitchInput from '../../../../Components/SwitchInput';
import { toast } from 'react-toastify';
import { throwErrorIfKeyNotPresentOrInvalid } from '../../../../utilities/helpers';
import { CONFIG_STRUCTURE_KEYS } from '../../constants';
import PageHeading from '../../../../Components/PageHeading';
import useCommonStyles from '../../../../commonStyles';
const { FLOOR_PRICING_CONFIG, ENABLED, LOGGING_VERSION, TRAFFIC_SPLIT } = CONFIG_STRUCTURE_KEYS;

const GeneralSettings = () => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const commonStyleClasses = useCommonStyles();
	const updateEnabled = (enabledValue) => {
		try {
			const clonedBannerFpConfig = structuredClone(bannerFpConfig);
			throwErrorIfKeyNotPresentOrInvalid(ENABLED, bannerFpConfig[FLOOR_PRICING_CONFIG], 'boolean');
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][ENABLED] = enabledValue;
			updateBannerFpConfig(clonedBannerFpConfig);
		} catch (err) {
			console.error(err);
			toast.error(err.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	const updateLoggingVersion = (loggingVersion) => {
		try {
			const clonedBannerFpConfig = structuredClone(bannerFpConfig);
			throwErrorIfKeyNotPresentOrInvalid(
				LOGGING_VERSION,
				bannerFpConfig[FLOOR_PRICING_CONFIG],
				'number'
			);
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][LOGGING_VERSION] = loggingVersion;
			updateBannerFpConfig(clonedBannerFpConfig);
		} catch (err) {
			console.error(err);
			toast.error(err.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	const updateTrafficSplit = (trafficSplit) => {
		try {
			const clonedBannerFpConfig = structuredClone(bannerFpConfig);
			throwErrorIfKeyNotPresentOrInvalid(
				TRAFFIC_SPLIT,
				bannerFpConfig[FLOOR_PRICING_CONFIG],
				'number'
			);
			clonedBannerFpConfig[FLOOR_PRICING_CONFIG][TRAFFIC_SPLIT] = trafficSplit;
			updateBannerFpConfig(clonedBannerFpConfig);
		} catch (err) {
			console.error(err);
			toast.error(err.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="General Settings"
				headingPath={['Dashboard', 'Banner Fp', 'Floor Pricing', 'General Settings']}
			/>
			<Grid container spacing={1} style={{ margin: '3rem 0 2rem 4rem', width: '90%' }}>
				{bannerFpConfig && (
					<>
						<Grid item xs={2}>
							<SwitchInput
								isObjectEditor={false}
								directValue={bannerFpConfig?.[FLOOR_PRICING_CONFIG]?.[ENABLED]}
								updateDirectValue={updateEnabled}
								label="Enabled"
								containerStyles={{ marginTop: '5rem' }}
							/>
						</Grid>
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpConfig?.[FLOOR_PRICING_CONFIG]?.[LOGGING_VERSION]}
								updateDirectValue={updateLoggingVersion}
								label="Logging Version"
								inputType="number"
							/>
						</Grid>
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpConfig?.[FLOOR_PRICING_CONFIG]?.[TRAFFIC_SPLIT]}
								updateDirectValue={updateTrafficSplit}
								label="Traffic Split"
								inputType="number"
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};
export default GeneralSettings;
